import { Dialog } from '@account/components/personal/dialog.js';
import { formList } from './data.js';
export const openDialog = {
  methods: {
    // 修改个人信息
    editAccount(item) {
      var form = formList.get(item.prop);
      Dialog({
        dialogVisible: true,
        title: '修改信息',
        formList: form,
        type: 'name',
        success: params => {
          console.log(params);
        },
      });
    },
  },
};
